import {
  Flex,
  Icon,
  spaces,
  Text,
  useBreakpoint,
  useCollapse,
} from '@electricjs/arc';

export const AssetDetailCollapsible = ({
  label,
  collapsedText,
  expandedText,
}: {
  label: string;
  collapsedText: string;
  expandedText: string;
}) => {
  const { space_xs, space_m } = spaces;
  const { visible, toggle } = useCollapse({ visible: false });
  const { xl } = useBreakpoint();

  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    // Prevents the grid card from going to the linked page on click
    e.stopPropagation();
    toggle();
  };

  return (
    <Flex width="100%" px={space_m} justifyContent="space-between">
      <Flex width="50%" alignItems="center">
        <Text variant="label-small">{label}</Text>
      </Flex>
      <Flex
        flexDirection="column"
        width="50%"
        alignItems={xl ? 'flex-start' : 'flex-end'}
        onClick={handleClick}
        data-arc="collapsible">
        <Flex alignItems="center" gap={space_xs}>
          {visible ? (
            <Icon icon="chevron-up" size="xsmall" />
          ) : (
            <Icon icon="chevron-down" size="xsmall" />
          )}
          <Text variant="body-2" textAlign={xl ? 'start' : 'end'}>
            {collapsedText}
          </Text>
        </Flex>
        {visible && (
          <Text variant="body-2" pt={space_xs} textAlign={xl ? 'start' : 'end'}>
            {expandedText}
          </Text>
        )}
      </Flex>
    </Flex>
  );
};
